import React, { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import './style/Payment-details.css';
import Loading from '../home/Loading';
import AboutApp from "../AllData/AboutApp";
import UsePaymentItems from "../Backend/UsePaymentItems";
import useUsersData from "../Auth/AllUsers";
import UseCoupon from "../Backend/UseCoupon";


function PaymentDetails() {

  const { item, userId } = useParams();

  const { allCoupon, loading: couponsLoading } = UseCoupon();
  const [couponCode, setCouponCode] = useState('');
  const [couponName, setCouponName] = useState('No');
  const [discount, setDiscount] = useState(0);
  const [couponMessage, setCouponMessage] = useState('');
  const [haveCoupon, setHaveCopuon] = useState(false);
  const { paymentItems, loading } = UsePaymentItems();
  const { users } = useUsersData();


  const itemNumber = decodeURIComponent(atob(item || '2'));
  const phone = decodeURIComponent(atob(userId || 'No'));

  const matchUser = users?.find(user => user.phone === phone);
  const userName = matchUser?.name || "No"
  const email = matchUser?.email || "No"


  const matchItem = paymentItems?.find(item => item.id === itemNumber);
  const name = matchItem?.name || "299";
  const price = matchItem?.price || "2";
  const about = matchItem?.about || "No";
  const valid = matchItem?.valid || "No";



  const handleCouponApply = () => {
    if (allCoupon.hasOwnProperty(couponCode)) {
      const couponValue = allCoupon[couponCode];

      if (typeof couponValue === 'number') {
        setDiscount(couponValue);
        setCouponName(couponCode);
        setCouponMessage(`Success! ${couponValue * 100}% discount applied.`);
      }
    } else {
      setDiscount(0);
      setCouponMessage('Invalid coupon code');
    }
  };

  const calculateDiscountedPrice = () => {
    return Math.round(price * (1 - discount));
  };

  const checkHaveCopuon = () => {
    setHaveCopuon(true);
  }


  const url = `https://neetapp.mystudyplace.in/share-payment-details/${item}/${userId}`;
  const appLink = `https://neetapp.mystudyplace.in/share-payment-details/${item}/${userId}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: AboutApp[0].name,
          text: AboutApp.title,
          url: url || window.location.href,
        });
        console.log('Shared successfully');
      } catch (error) {
        console.log('Error sharing:', error);
      }
    } else if (window.Android && window.Android.shareLink) {
      window.Android.shareLink(appLink);
    }
    else {
      // Fallback: copy to clipboard
      copyToClipboard(url || window.location.href);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('Link copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };



  if (loading) {
    return <Loading message="Loading....." />
  }

  return (
    <>

      <div className="payment-container">
        <div className="payment-section">
          <div className="note-details">
            <h2 className="note-title">You can access {name} </h2>
            <div className="detail-row">
              <span className="detail-value">{userName}, {about}.</span>
            </div>
            <div className="detail-row">
              <p>{valid}</p>

            </div>


            {/* 
           
            {haveCoupon ? (
              <>
                <div className="coupon-section">
                  <input
                    type="text"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                    placeholder="Enter coupon code"
                    className="coupon-input"
                  />
                  <button
                    onClick={handleCouponApply}
                    className="apply-coupon-button"
                  >
                    Apply
                  </button>
                </div>
              </>
            ) : (
              <>
                <button onClick={() => checkHaveCopuon()} className="coupon-btn">
                  Have a coupon
                </button>
              </>
            )}
            
            */}

            {couponMessage && (
              <div className={`coupon-message ${discount > 0 ? 'success' : 'not-success'}`}>
                {couponMessage}
              </div>
            )}


          </div>

          <Link
            to={`/pay/${item}/${userId}`}
            className="payment-button"
          >
            🔑 Purchase ONLY { } ₹{calculateDiscountedPrice()}  {discount > 0 && (<><span className="original-price">{price}</span></>)}
          </Link>


          <button
            onClick={handleShare}
            className="payment-button"
          >
            <span>Share payment link</span>
          </button>


          <div style={{
            marginTop: '24px',
            padding: '16px',
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef',
            fontSize: '14px',
            color: '#333',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            <p style={{ margin: '0 0 4px 0', fontWeight: '600', color: '#6c757d', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Purchase For:
            </p>
            <div><strong style={{ color: '#495057' }}>Name:</strong> {userName || 'Not found'}</div>
            <div><strong style={{ color: '#495057' }}>Phone:</strong> {phone || 'Not found'}</div>
            <div><strong style={{ color: '#495057' }}>Email:</strong> {email}</div>
            <div style={{ marginTop: '4px', paddingTop: '8px', borderTop: '1px solid #e9ecef', fontSize: '16px', fontWeight: 'bold', color: '#0d6efd' }}>
              Amount: ₹ {price}
            </div>
          </div>

        </div>
      </div>

    </>
  );
}

export default PaymentDetails;